import { render, staticRenderFns } from "./testimonals.vue?vue&type=template&id=7f51f1b8&"
import script from "./testimonals.vue?vue&type=script&lang=js&"
export * from "./testimonals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports